import { render, staticRenderFns } from "./History.vue?vue&type=template&id=270eb80e&"
import script from "./History.vue?vue&type=script&lang=js&"
export * from "./History.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kael-cadranel/Sites/apps.chateaudeseneffe.be/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('270eb80e')) {
      api.createRecord('270eb80e', component.options)
    } else {
      api.reload('270eb80e', component.options)
    }
    module.hot.accept("./History.vue?vue&type=template&id=270eb80e&", function () {
      api.rerender('270eb80e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/History.vue"
export default component.exports